import { Action } from "@ngrx/store";
import {
  FacetFilters,
  FilterEvent,
  ChartFilters,
  GridSettings,
  SavedFilterObj,
} from "../models/pharma-page-store.model";

export const FACET_FILTER_CHANGED = "FACET_FILTER_CHANGED";
export const CHART_FILTER_CHANGED = "CHART_FILTER_CHANGED";
export const FILTER_EVENT_CHANGED = "FILTER_EVENT_CHANGED";
export const GRID_SETTINGS_CHANGED = "GRID_SETTINGS_CHANGED";
export const SAVED_FILTER_CHANGED = "SAVED_FILTER_CHANGED";
export const UPDATE_PILLS = "UPDATE_PILLS";

export class FacetFilterChanged implements Action {
  readonly type = FACET_FILTER_CHANGED;
  constructor(public payload: FacetFilters) {}
}
export class ChartFilterChanged implements Action {
  readonly type = CHART_FILTER_CHANGED;
  constructor(public payload: ChartFilters) {}
}
export class FilterEventChanged implements Action {
  readonly type = FILTER_EVENT_CHANGED;
  constructor(public payload: FilterEvent) {}
}
export class GridSettingsChanged implements Action {
  readonly type = GRID_SETTINGS_CHANGED;
  constructor(public payload: GridSettings) {}
}
export class SavedFilterChanged implements Action {
  readonly type = SAVED_FILTER_CHANGED;
  constructor(public payload: SavedFilterObj) {}
}
export class UpdatePills implements Action {
  readonly type = UPDATE_PILLS;
  constructor(public payload: any) {}
}
export type Actions =
  | FacetFilterChanged
  | ChartFilterChanged
  | FilterEventChanged
  | SavedFilterChanged
  | GridSettingsChanged
  | UpdatePills;
